import React from "react";

import { Outlet } from "react-router-dom";
import NavbarLeftIntranet from "../navbar/NavbarLeftIntranet";
import NavbarTop from "../navbar/NavbarTop";
import Footer from "../footer/Footer";


const LayoutIntranet = ({ current }) => {
  return (
    <>
      <div className='min-h-screen'>
        <NavbarTop />
        <NavbarLeftIntranet current={current} />

        <div className='flex flex-col ml-36 min-h-screen justify-between'>
          <div><Outlet /></div>
          
          <div><Footer /></div>
        </div>
      </div>
    </>
  );
};

export default LayoutIntranet;